import { render } from "./ErpList.vue?vue&type=template&id=37bf8533&scoped=true"
import script from "./ErpList.vue?vue&type=script&lang=js"
export * from "./ErpList.vue?vue&type=script&lang=js"

import "./ErpList.vue?vue&type=style&index=0&id=37bf8533&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf8533"]])

export default __exports__